import request from "@/utils/request.js";

/**
 * 获取卡片模板列表
 */
export function getCardTemplates(params) {
  return request({
    url: "/card_templates",
    method: "get",
    params
  });
}
/**
 * 添加卡片模板
 * params: {
 *  "name": "项目任务测试模板test",
    "category": "ProjectTasktest",
    "content": "** 项目任务测模板, 请勿直接使用 **\r\n\r\nSeat: {% seat %}\r\n\r\nType: Telephone\r\n\r\n项目助理: {% pa %}\r\n\r\nConference Time: {% start_time %} ~ {% end_time %}\r\n\r\nDial-in number: SH:021-34994556 BJ:010-58084288 Other:400-810-5222\r\n\r\nCode:\r\n\r\n{% expert_level %} # {% expert_uid %} {% expert_mr_name %}\r\n\r\n【公司】{% expert_company %}\r\n\r\n【职位】{% expert_title %}\r\n\r\n【背景】{% expert_description %}\r\n\r\n【倍率】{% expert_rate %}\r\n____________________________________________________________________________________\r\n\r\n专家单价: {% expert_unit_price %}",
    "user_channel_id": 2
 * }
 */
export function addCardTemplate(data) {
  return request({
    url: "/card_templates",
    method: "post",
    data
  });
}
/**
 * 获取卡片模板详情
 */
export function getCardTemplateDetail(id) {
  return request({
    url: `/card_templates/${id}`,
    method: "get"
  });
}
/**
 * 修改卡片模板详情
 */
export function editCardTemplate(id, data) {
  return request({
    url: `/card_templates/${id}`,
    method: "put",
    data
  });
}
/**
 * 删除卡片模板
 */
export function deleteCardTemplate(id) {
  return request({
    url: `/card_templates/${id}`,
    method: "delete"
  });
}

/**
 * 获取银行列表
 */
export function getBanks(params) {
  return request({
    url: "/banks",
    method: "get",
    params
  });
}
/**
 * 获取银行详情
 */
export function getBankDetail(id) {
  return request({
    url: `/banks/${id}`,
    method: "get"
  });
}
/**
 * 修改银行详情
 */
export function editBank(id, data) {
  return request({
    url: `/banks/${id}`,
    method: "put",
    data
  });
}
/**
 * 修改银行详情
 */
export function deleteBank(id) {
  return request({
    url: `/banks/${id}`,
    method: "delete"
  });
}
/**
 * 添加银行
 */
export function addBank(data) {
  return request({
    url: `/banks`,
    method: "post",
    data
  });
}

/**
 * 获取支付主体列表
 */
export function getPaymentCompanies(params) {
  return request({
    url: "/payment-companies",
    method: "get",
    params
  });
}
/**
 * 获取支付主体详情
 */
export function getPaymentCompanyDetail(id) {
  return request({
    url: `/payment-companies/${id}`,
    method: "get"
  });
}
/**
 * 修改支付主体详情
 */
export function editPaymentCompany(id, data) {
  return request({
    url: `/payment-companies/${id}`,
    method: "put",
    data
  });
}
/**
 * 删除支付主体
 */
export function deletePaymentCompany(id) {
  return request({
    url: `/payment-companies/${id}`,
    method: "delete"
  });
}
/**
 * 添加支付主体
 */
export function addPaymentCompany(data) {
  return request({
    url: `/payment-companies`,
    method: "post",
    data
  });
}

export function getTranslationVendors(params) {
  return request({
    url: "/translation-vendors",
    method: "get",
    params
  });
}

export function getTranslationVendorDetail(id) {
  return request({
    url: `/translation-vendors/${id}`,
    method: "get"
  });
}

export function addTranslationVendor(data) {
  return request({
    url: "/translation-vendors",
    method: "post",
    data
  });
}

export function editTranslationVendor(id, data) {
  return request({
    url: `/translation-vendors/${id}`,
    method: "put",
    data
  });
}

export function deleteTranslationVendor(id) {
  return request({
    url: `/translation-vendors/${id}`,
    method: "delete"
  });
}

/**
 * 获取行业列表
 */
export function getIndustries(params) {
  return request({
    url: "/industries",
    method: "get",
    params
  });
}
/**
 * 获取银行详情
 */
export function getIndustriesDetail(id) {
  return request({
    url: `/industries/${id}`,
    method: "get"
  });
}
/**
 * 修改银行详情
 */
export function editIndustries(id, data) {
  return request({
    url: `/industries/${id}`,
    method: "put",
    data
  });
}
/**
 * 修改银行详情
 */
export function deleteIndustries(id) {
  return request({
    url: `/industries/${id}`,
    method: "delete"
  });
}
/**
 * 添加银行
 */
export function addIndustries(data) {
  return request({
    url: `/industries`,
    method: "post",
    data
  });
}
